import { Caption1Reg, ParagraphMBold } from '../../config/designSystem/typography';
import { SPACING } from '../../config/designSystem/Spacing';
import { StyleSheet, View } from 'react-native';

export const InfoItem = ({name = '', value = ''}) => {
  return (
    <View style={styles.item}>
      <ParagraphMBold>
        {name}
      </ParagraphMBold>
      <Caption1Reg>
        {value}
      </Caption1Reg>
    </View>
  );
};

const styles = StyleSheet.create({
  item: {
    flexDirection: 'column',
    paddingLeft: SPACING['sp-64'] - SPACING['sp-4'],
    marginVertical: SPACING['sp-2'],
  }
});
